/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiCaseStatus
 */
export interface InternalApiCaseStatus {
    /**
     * 
     * @type {string}
     * @memberof InternalApiCaseStatus
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCaseStatus
     */
    textName: string;
}

/**
 * Check if a given object implements the InternalApiCaseStatus interface.
 */
export function instanceOfInternalApiCaseStatus(value: object): value is InternalApiCaseStatus {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('textName' in value) || value['textName'] === undefined) return false;
    return true;
}

export function InternalApiCaseStatusFromJSON(json: any): InternalApiCaseStatus {
    return InternalApiCaseStatusFromJSONTyped(json, false);
}

export function InternalApiCaseStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCaseStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'textName': json['textName'],
    };
}

export function InternalApiCaseStatusToJSON(json: any): InternalApiCaseStatus {
    return InternalApiCaseStatusToJSONTyped(json, false);
}

export function InternalApiCaseStatusToJSONTyped(value?: InternalApiCaseStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'textName': value['textName'],
    };
}

